import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import "./index.css";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import AppErrorBoundary from "./components/AppErrorBoundary";
import { msalConfig } from "./config/msal";
import { store } from "./store/store";
import { theme } from "./theme";

// Blob caching is handled by the browser HTTP cache (the blob endpoint sends
// `Cache-Control: immutable`). The old blob-caching Service Worker is gone — unregister
// any copy still installed in returning users' browsers and drop its caches, otherwise it
// would keep serving stale (and previously error-cached) responses.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => void r.unregister()));
  if ("caches" in window) {
    caches.keys().then((keys) => keys.filter((k) => k.startsWith("blob-")).forEach((k) => void caches.delete(k)));
  }
}

const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();
await msalInstance.handleRedirectPromise();

const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) msalInstance.setActiveAccount(accounts[0]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <MantineProvider theme={theme} defaultColorScheme="auto">
          <AppErrorBoundary>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </AppErrorBoundary>
        </MantineProvider>
      </Provider>
    </MsalProvider>
  </StrictMode>,
);
